import { useState } from 'react';
import dayjs from 'dayjs';
import { DateRange, DateRangeProps, Range } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { makeStyles, Popover } from '@material-ui/core';
import { MDSButton, MDSPlainButton, MDSIcon } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  popover: {
    marginTop: '4px',
  },
  footer: {
    padding: '0 20px 20px',
    backgroundColor: 'white',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttons: {
    display: 'flex',
    gap: '8px',
  },
});

export interface IDateRange {
  startDate: string | null;
  endDate: string | null;
}

type Props = {
  anchorEl: Element;
  onClose: () => void;
  onApply: (date: IDateRange) => void;
  onReset?: () => void;
  data?: IDateRange | null;
};

const DatePopup = (props: Props & DateRangeProps) => {
  const classes = useStyles();

  const { anchorEl, onClose, onApply, onReset, data, ...restProps } = props;

  const [datepickerDisabled, setDatepickerDisabled] = useState(true);
  const [dateRange, setDateRange] = useState<Range[]>([
    {
      key: 'selection',
      startDate: dayjs(data?.startDate || undefined).toDate(),
      endDate: dayjs(data?.endDate || undefined).toDate(),
    },
  ]);

  const handleDatePickerChange = (value: Range[]) => {
    setDateRange(value);
    setDatepickerDisabled(false);
  };

  const handleDatePickerReset = () => {
    setDatepickerDisabled(true);
    setDateRange([
      {
        key: 'selection',
        startDate: dayjs(data?.startDate || undefined).toDate(),
        endDate: dayjs(data?.endDate || undefined).toDate(),
      },
    ]);
    onClose();
  };

  const handleDatePickerApply = () => {
    onApply({
      startDate: dayjs(dateRange[0].startDate).format('YYYY-MM-DD'),
      endDate: dayjs(dateRange[0].endDate).format('YYYY-MM-DD'),
    });
  };

  return (
    <Popover
      open={true}
      anchorEl={anchorEl}
      onClose={onClose}
      className={classes.popover}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <DateRange
        moveRangeOnFirstSelection={false}
        onChange={(item) => handleDatePickerChange([item.selection])}
        months={2}
        ranges={dateRange}
        direction="horizontal"
        {...restProps}
      />
      <div className={classes.footer}>
        <div className={classes.buttons}>
          {onReset && data && (
            <MDSPlainButton color="blue" size="small" startIcon={<MDSIcon.Reset />} onClick={onReset}>
              Reset
            </MDSPlainButton>
          )}
        </div>
        <div className={classes.buttons}>
          <MDSButton variant="border" color="bluegray" size="medium" onClick={handleDatePickerReset}>
            Cancel
          </MDSButton>
          <MDSButton
            variant="fill"
            size="medium"
            color="blue"
            isDisabled={datepickerDisabled}
            onClick={handleDatePickerApply}
          >
            Apply
          </MDSButton>
        </div>
      </div>
    </Popover>
  );
};

export default DatePopup;
